<wr-new-data-table headerText="TGAs"
                   localStorageIdentifier="external-building-equipment-overview"
                   [loadItemsFunction]="loadBuildingEquipments"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToBuildingEquipment($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="creatorTenantSelect">Firmen</label>
          <wr-tenant-select id="creatorTenantSelect"
                                  formControlName="creatorTenantId"
                                  [tenantType]="TenantTypeEnum.Internal"
                                  [showEmptyOption]="true"></wr-tenant-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="equipmentSelect">TGA Baupläne</label>
          <wr-tga-type-select [tenantId]="form.get('creatorTenantId')?.value" id="equipmentSelect" formControlName="equipment"></wr-tga-type-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="buildingSelect">Gebäude</label>
          <wr-building-select id="buildingSelect"
                              formControlName="building"
                              [tenantId]="currentTenantId()">
          </wr-building-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="facilityElementSelect">Technische Einrichtung</label>
          <wr-facility-element-select id="facilityElementSelect"
                                      formControlName="facilityElement"
                                      [showEmptyOption]="true"
          ></wr-facility-element-select>
        </div>
        <wr-equipment-field-filter
          [equipment]="form.get('equipment')?.value"
          formControlName="customFieldFilters">
        </wr-equipment-field-filter>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-buildingEquipment
    key="equipmentName"
    exportKey="equipment.name"
    display="TGA Bauplan">
    <wr-tga-type-badge [tgaType]="buildingEquipment.equipment"></wr-tga-type-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-buildingEquipment
    key="quantity"
    display="Anzahl">
    @if (buildingEquipment.quantity) {
      <div>{{buildingEquipment.quantity}}</div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-buildingEquipment
    key="building"
    exportKey="buildingSection.sectionText"
    display="Gebäudeteil">
    <wr-building-section-badge [buildingSection]="buildingEquipment.buildingSection"></wr-building-section-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-buildingEquipment
    key="creatorTenant"
    exportKey="creatorTenant.name"
    display="Firma">
    <wr-tenant-badge [tenant]="buildingEquipment.creatorTenant" [disableLink]="true"></wr-tenant-badge>
  </ng-template>
    <ng-template
            dataColumn
            let-buildingEquipment
            key="maintenanceTimerCount"
            display="Wartungstimer"
            [sortable]="false">
        <div>
            {{buildingEquipment.maintenanceTimerCount}}
        </div>
    </ng-template>
</wr-new-data-table>
